<template>
    <v-container style="max-width:100vw;">
        <!-- Filtros -->
        <v-navigation-drawer style="top: 0px; max-height:100vh!important;" right v-model="filters" :clipped="$vuetify.breakpoint.lgAndUp" app>
            <filterSales v-bind:company="company" @filtersSale="filtersSale"/>
        </v-navigation-drawer>
        <!-- Totalizadores -->
        <totals v-if="this.company==undefined"/>
        <!--header-->
        <v-toolbar flat class="px-4 pt-3">
            <v-toolbar-title>
                Ventas
                <br/>
                <span style="font-size:12px; color:grey; position: absolute;" v-if="filterStorage() && !routeSaleId">Mes Actual</span>
            </v-toolbar-title>
            <v-chip v-if="routeSaleId" class="ml-4" small close color="primary" @click:close="clearRouteSale()">Venta #{{routeSaleId}}</v-chip>


            <v-btn icon class="ml-6 pt-2" v-if="filterStorageLength== undefined" @click="openFilter()">
                <v-icon>mdi-filter</v-icon>
            </v-btn>


             <v-btn icon class="ml-6" v-else @click="openFilter()">
                <v-badge overlap color="primary">
                    <template v-slot:badge>
                        {{filterStorageLength}}
                    </template>
                    <v-icon>mdi-filter</v-icon>
                </v-badge>
            </v-btn>
            <!--v-btn icon>
                <v-icon @click="tableGraph=false" v-if="tableGraph">mdi-chart-bell-curve-cumulative</v-icon>
                <v-icon @click="tableGraph=true" v-else>mdi-periodic-table</v-icon>
            </v-btn-->
            <v-spacer></v-spacer>
            <v-menu bottom left offset-y v-show="permissions('download')">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" :loading="exporting">
                        <v-icon>mdi-download</v-icon>
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-item @click="exportExcel(false)">
                        Lo que se ve en pantalla
                    </v-list-item>
                    <v-list-item @click="exportExcel(true)">
                        Todo
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>
        <!-- Tabla -->
        <v-data-table 
        height="calc(100vh - 300px)"
        fixed-header
        :footer-props="{'items-per-page-options':[15, 30, 50, salesLength]}"
        v-if="showTable && tableGraph"
        :headers="headers" 
        :items="sales"
        class="elevation-0 px-6 pb-4 pt-10"
        :options.sync="options"
        :server-items-length="totalSales"
        :loading="loading"
        :item-class="itemRowBackground" 
        show-expand>

                <template v-slot:[`item.total`]="{ item }">
                    {{(item.total*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}
                </template>
                <template v-slot:[`item.subtotal`]="{ item }">
                    {{(item.subtotal*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}
                </template>
                <template v-slot:[`item.iva`]="{ item }">
                    {{(item.iva*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}  
                </template>
                

            <template v-slot:[`item.printed`]="{ item }">
                <v-icon v-if="item.printed!=true" color="grey"> mdi-close </v-icon>
                <v-icon v-else color="primary"> mdi-check </v-icon>
            </template>
            <template v-slot:[`item.invoice`]="{ item }">
                <v-list-item v-if="item.facturapi_invoices.length>0" :to="{ path: '/invoices/'+ item.facturapi_invoices[0].id}">{{item.invoice}}</v-list-item>
            </template>
            <!-- Acciones por fila -->
            <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                    </template>
                    <v-list style="font-size:13px;">
                        <!--v-tooltip left v-if="item.production_dispatched">
                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item disabled class="px-0">
                                        <v-icon small class="mr-2">
                                            mdi-pencil
                                        </v-icon>
                                        Editar
                                    </v-list-item>
                                </v-list-item>
                            </template>
                            <span>Esta venta ya se surtió</span>
                        </v-tooltip>
                        <v-tooltip left v-else-if="item.is_in_production">
                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item disabled class="px-0">
                                        <v-icon small class="mr-2">
                                            mdi-pencil
                                        </v-icon>
                                        Editar
                                    </v-list-item>
                                </v-list-item>
                            </template>
                            <span>Esta venta esta en producción</span>
                        </v-tooltip-->

                        <v-list-item @click="generateInvoice(item)" v-if="permissions('generateInvoice') && ((item.facturapi_invoices!=undefined && item.facturapi_invoices.length<1) || permissions('regenerateInvoice')) && item.status != 'cancelled'">
                            <v-icon small class="mr-2">
                                mdi-file-document
                            </v-icon>
                            {{item.facturapi_invoices.length<1?'Generar Factura':'Refacturar'}}
                        </v-list-item>


                        <v-list-item @click="editItem(item.id)" v-show="permissions('editSales')">
                            <v-icon small class="mr-2">
                                mdi-pencil
                            </v-icon>
                            Editar
                        </v-list-item>

                        <v-tooltip left v-if="item.production_dispatched" v-show="permissions('deleteSales')">
                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item :disabled="true" class="px-0">
                                        <v-icon small class="mr-2">
                                            mdi-delete
                                        </v-icon>
                                        Eliminar
                                    </v-list-item>
                                </v-list-item>
                            </template>
                            <span>Esta venta ya se surtió</span>
                        </v-tooltip>
                        <v-tooltip left v-else-if="item.is_in_production" v-show="permissions('deleteSales')">
                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item :disabled="true" class="px-0">
                                        <v-icon small class="mr-2">
                                            mdi-delete
                                        </v-icon>
                                        Eliminar
                                    </v-list-item>
                                </v-list-item>
                            </template>
                            <span>Esta venta esta en producción</span>
                        </v-tooltip>
                        <v-list-item v-else @click="deleteItem(item)" v-show="permissions('deleteSales')">
                            <v-icon small class="mr-2">
                                mdi-delete
                            </v-icon>
                            Eliminar
                        </v-list-item>

                        <v-list-item v-if="liga!='https://backendmf.unocrm.mx/'" @click="sendEmail(item.id)">
                            <v-icon small class="mr-2">
                                mdi-email
                            </v-icon>
                            Enviar Venta por Correo
                        </v-list-item>
                        <v-list-item @click="sendInvoiceEmail(item)" v-if="item.facturapi_invoices!=undefined && item.facturapi_invoices.length>=1">
                            <v-icon small class="mr-2">
                                mdi-email
                            </v-icon>
                            Enviar Factura por Correo
                        </v-list-item>
                        <v-list-item @click="printTicket(item)" v-show="permissions('printTicket')==true"><!--item.printed!=true && -->
                            <v-icon small class="mr-2">
                                mdi-printer
                            </v-icon>
                            Imprimir ticket
                        </v-list-item>

                        <v-list-item
                            @click="openCollection(item)"
                            v-show="permissions('collections') && Number(item.due_balance_raw || 0) > 0"
                        >
                            <v-icon small class="mr-2">
                                mdi-cash-plus
                            </v-icon>
                            Aplicar cobranza
                        </v-list-item>

                        <v-list-item @click="rejection(item)" v-if="item.status!='cancelled'&&(liga != 'https://backendmf.unocrm.mx/' || permissions('canCancell'))">
                            <v-list-item class="px-0">
                                <v-icon small class="mr-2">
                                    mdi-close
                                </v-icon>
                                Cancelar
                            </v-list-item>
                        </v-list-item>

                        <v-list-item @click="openDuplicate(item.id)" v-show="canCreateSales">
                            <v-icon small class="mr-2">mdi-content-copy</v-icon>
                            Duplicar
                        </v-list-item>

                    </v-list>
                </v-menu>
            </template>
            <!-- Tabla sin información -->
            <template v-slot:no-data>
                No existen registros de ventas aún
            </template>
            <!-- Empresa -->
            <template v-slot:[`item.company_id`]="{ item }">
                <v-list-item class="px-0" style="min-height:0px!important; font-size:14px;" :to="{ path: '/clients/client/'+ item.companyID}">{{item.company_id}}</v-list-item>
            </template>

            <template v-slot:[`item.collections_date`]="{ item }">
                <span v-for="(collection, index) in item.collections_date" :key="index">{{collection.date + (index+1<(item.collections_date.length)?', ':'')}}</span>
            </template>
            <template v-slot:[`item.collections`]="{ item }">
                <v-chip-group>
                    <v-chip x-small v-for="(collection_id, index) in item.collections" :key="index" :to="{ path: '/new-collections/' + collection_id }">{{collection_id}}</v-chip>
                </v-chip-group>
            </template>
            <!-- Envio -->
            <template v-slot:[`item.shipping_date`]="{ item }">
                <span v-if="item.shipping_date!=undefined&&item.shipping_date!=null">{{item.shipping_date}}</span>
                <template v-else-if="item.production_dispatched==1">
                    <span v-if="item.shipping!=null&&item.shipping.shipping_details[0].completed">Enviado ({{item.shipping.date}})</span>
                    <a style="color:black; text-decoration:none;" v-else-if="item.shipping!=null&&item.bar!=1" :href="'#/shippings/'+ item.shipping.id">En envío ({{item.shipping.id}})</a>
                    <span v-else-if="item.bar">Mostrador ({{item.date}})</span>
                </template>
                <span v-else-if="item.production_dispatched!=1&&item.shipping==null">No surtido</span>
            </template>
            <template v-slot:[`item.production_dispatched`]="{ item }">
                <v-icon v-if="item.production_dispatched==true">mdi-check</v-icon>
                <v-icon v-else>mdi-close</v-icon>
            </template>
            <!-- Mostrador -->
            <template v-slot:[`item.bar`]="{ item }">
                <v-icon v-if="item.bar==true">mdi-check</v-icon>
                <v-icon v-else>mdi-close</v-icon>
            </template>

            <template v-slot:[`item.company_branch`]="{ item }">
                <span v-if="item.company_branch!=undefined">{{item.company_branch.name}}</span>
            </template>
            <!-- Detalle PC -->
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="pb-4"><!-- v-if="permissions('sale_details')"-->
                    <v-row class="pa-6 pb-0">
                        <v-col cols="12" sm="6" md="6">
                            <v-data-table hide-default-footer :items-per-page="item.items.length" :headers="headers2" :items="item.items" v-if="item.items!=undefined" class="elevation-0" style="background: #f7f7f7;!important" dense>
                                <template v-slot:footer>
                                    <v-container style="max-width: 100%!important;">

                                        <v-tooltip right v-if="item.production_dispatched && liga!='https://backendmf.unocrm.mx/'">
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    <v-btn v-if="canCreateSales" :disabled="item.production_dispatched" small class="elevation-0" color="primary" rounded @click="addProduct(item.id)"> Agregar Producto</v-btn>
                                                </span>
                                            </template>
                                            <span>Esta venta ya se surtió</span>
                                        </v-tooltip>
                                        <v-tooltip right v-else-if="item.is_in_production && liga!='https://backendmf.unocrm.mx/'">
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    <v-btn v-if="canCreateSales" :disabled="item.is_in_production" small class="elevation-0" color="primary" rounded @click="addProduct(item.id)"> Agregar Producto</v-btn>
                                                </span>
                                            </template>
                                            <span>Esta venta esta en producción</span>
                                        </v-tooltip>
                                        <v-btn v-else-if="canCreateSales&&(liga!='https://backendmf.unocrm.mx/'||(!item.production_dispatched&&!item.is_in_production))&&liga!='https://backendbdb.unocrm.mx/'" :disabled="item.is_in_production==1" small class="elevation-0" color="primary" rounded @click="addProduct(item)"> Agregar Producto</v-btn>

                                        <v-divider vertical class="mx-2"></v-divider>
                                        <a v-if="item.company_branch!=null&&item.company_branch.address!=null" style="text-decoration:none" :href="'https://www.google.com.mx/maps/place/' + item.company_branch.address + '/@25.5895026,-103.4046855,15z/data=!3m1!4b1?entry=ttu&g_ep=EgoyMDI0MDkyNS4wIKXMDSoASAFQAw%3D%3D'" target="_blank" class="mx-3">
                                            <v-icon class="mr-4">mdi-map-marker-outline</v-icon>
                                            <span>{{item.company_branch.address}}</span>
                                        </a>
                                        <a v-else style="text-decoration:none" :href="'https://www.google.com.mx/maps/place/' + item.delivery_address + '/@25.5895026,-103.4046855,15z/data=!3m1!4b1?entry=ttu&g_ep=EgoyMDI0MDkyNS4wIKXMDSoASAFQAw%3D%3D'" target="_blank" class="mx-3">
                                            <v-icon class="mr-4">mdi-map-marker-outline</v-icon>
                                            <span>{{item.delivery_address}}</span>
                                        </a>

                                    </v-container>
                                </template> 
                                <template v-slot:[`item.item`]="{ item }">
                                    {{ item.item.name }}
                                </template>
                                <template v-slot:[`item.macro`]="{ item }">
                                    <span v-if="liga == 'https://suministros.uno/'">{{ item.item.macro }}</span>
                                    <span v-else-if="liga == 'https://backend.ferreteriaenlinea.com/'">{{ item.item.code_one }}</span>
                                </template>
                                <template v-slot:[`item.value`]="{ item }">
                                    {{ (item.value*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}) }}
                                </template>
                                <template v-slot:[`item.price`]="{ item }">
                                    {{ (item.price*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}) }} 
                                </template>
                                <template v-slot:[`item.price_iva`]="{ item }">
                                    {{ (item.price*1.16).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}) }} 
                                </template>
                                <template v-slot:[`item.discount`]="{ item }">
                                    {{item.discount!=null?item.discount + '%':0}}
                                </template>
                                <template v-slot:[`item.total`]="{ item }">
                                    {{ (item.price*item.quantity).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}) }}
                                </template>
                                <template v-slot:[`item.weight`]="{ item }">
                                    {{ item.item.weight }} kg
                                </template>
                                <template v-slot:[`item.code_one`]="{ item }">
                                    {{ item.item.code_one }}
                                </template>
                                
                                <template v-slot:[`item.totalWeight`]="{ item }">


                                    <span v-if="item.item!=undefined && item.item.unit!=undefined && item.item.unit.name=='Kilo'">{{ item.item.weight!=null?item.item.weight*item.quantity:item.quantity }} kgs</span>
                                    <span v-else-if="item.item!=undefined && item.item.unit!=undefined && item.item.unit.name=='Pieza'">{{ item.quantity }} pzas</span>

                                    <span v-else>{{ item.quantity }} </span>

                                    <span v-if="item.rejection_status!=null">({{item.rejection_status}})</span>


                                </template>
                                <template v-slot:[`item.cost`]="{ item }">
                                    {{ (item.cost*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}) }} 
                                </template>
                                <template v-slot:[`item.total_cost`]="{ item }">
                                    {{ (item.cost*item.quantity).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}) }} 
                                </template>
                                <template v-slot:[`item.utility_per_item`]="{ item }">
                                    {{ ((item.price*1)-(item.cost*1)).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}) }} 
                                </template>
                                <template v-slot:[`item.utility`]="{ item }">
                                    {{ ((item.price*item.quantity)-(item.cost*item.quantity)).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}) }} 
                                </template>

                                 <!-- Acciones por fila -->
                                <template v-slot:[`item.actions`]="{ item }">
                                    <v-menu bottom left>
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                        </template>
                                        <v-list style="font-size:13px;">
                                            <v-tooltip left v-if="item.production_dispatched">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-list-item v-bind="attrs" v-on="on">
                                                        <v-list-item disabled class="px-0">
                                                            <v-icon small class="mr-2">
                                                                mdi-pencil
                                                            </v-icon>
                                                            Editar
                                                        </v-list-item>
                                                    </v-list-item>
                                                </template>
                                                <span>Esta venta ya se surtió</span>
                                            </v-tooltip>
                                            <v-tooltip left v-else-if="item.is_in_production">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-list-item v-bind="attrs" v-on="on">
                                                        <v-list-item disabled class="px-0">
                                                            <v-icon small class="mr-2">
                                                                mdi-pencil
                                                            </v-icon>
                                                            Editar
                                                        </v-list-item>
                                                    </v-list-item>
                                                </template>
                                                <span>Esta venta esta en producción</span>
                                            </v-tooltip>
                                            <v-list-item v-else @click="editDetail(item.id)" v-show="permissions('editSaleDetail')">
                                                <v-icon small class="mr-2">
                                                    mdi-pencil
                                                </v-icon>
                                                Editar
                                            </v-list-item>

                                            <v-tooltip left v-if="item.production_dispatched">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-list-item v-bind="attrs" v-on="on">
                                                        <v-list-item :disabled="true" class="px-0">
                                                            <v-icon small class="mr-2">
                                                                mdi-delete
                                                            </v-icon>
                                                            Eliminar
                                                        </v-list-item>
                                                    </v-list-item>
                                                </template>
                                                <span>Esta venta ya se surtió</span>
                                            </v-tooltip>
                                            <v-tooltip left v-else-if="item.is_in_production">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-list-item v-bind="attrs" v-on="on">
                                                        <v-list-item :disabled="true" class="px-0">
                                                            <v-icon small class="mr-2">
                                                                mdi-delete
                                                            </v-icon>
                                                            Eliminar
                                                        </v-list-item>
                                                    </v-list-item>
                                                </template>
                                                <span>Esta venta esta en producción</span>
                                            </v-tooltip>
                                            <v-list-item v-else @click="deleteDetail(item.id)" v-show="permissions('deleteSaleDetail')">
                                                <v-icon small class="mr-2">
                                                    mdi-delete
                                                </v-icon>
                                                Eliminar
                                            </v-list-item>
                                            
                                            
                                            

                                            <!--v-btn outlined rounded color="red" class="mt-4"  style="font-size:12px; height:30px!important; margin-left: auto; margin-right: auto; display: block;">Cancelar</v-btn-->
                                        </v-list>
                                    </v-menu>
                                </template>
                            </v-data-table>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="px-6">
                            <div class="px-4 py-3" style="background-color:#ffedb3; border-radius: 0px 10px 10px 10px; min-height:120px;" >
                                <strong>Notas:</strong><br>
                                <span v-if="liga == 'https://suministros.uno/'">{{item.internal_note}}</span>
                                 <span v-else>{{item.note}}</span>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <span><strong>Orden de Compra: </strong>{{item.note}}</span>
                            <br/>
                            <!--span v-if="liga=='https://backendmf.unocrm.mx/'"><strong>Pagaré: </strong>{{item.internal_note}}</span-->
                            <div class="pt-3">
                            <v-btn v-if="item.pdf2!=undefined" v-bind:href="liga + 'files/' + item.pdf2" target="_blank" class="elevation-0" rounded color="primary">
                                <v-icon small>mdi-file-document-outline</v-icon> OC
                                
                            </v-btn>
                            <v-btn v-if="item.facturapi_invoices!=undefined && item.facturapi_invoices.length>0" @click="downloadInvoice(item.facturapi_invoices)" target="_blank" outlined rounded color="primary">
                                <v-icon small>mdi-file-document-outline</v-icon> Factura
                            </v-btn>
                            <v-btn v-if="item.facturapi_invoices!=undefined && item.facturapi_invoices.length>0" @click="downloadXml(item.facturapi_invoices)" target="_blank" outlined rounded color="primary">
                                <v-icon small>mdi-file-document-outline</v-icon> XML
                            </v-btn>
                            <v-btn v-if="item.pdf!=''&&item.pdf!=null&&item.pdf!=undefined&&item.pdf.length>0" v-bind:href="liga + 'files/' + item.pdf" target="_blank" outlined rounded color="primary">
                                <v-icon small>mdi-file-document-outline</v-icon> Factura Envío
                            </v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </td>
            </template>
        </v-data-table>
        <!-- Grafica>
        <v-card class="elevation-0" v-if="showTable && tableGraph==false"> 
        </v-card-->
        <!-- Crear venta -->
        <v-dialog v-if="canCreateSales" v-model="createDialog" max-width="900px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn bottom color="#e25200" dark fab fixed right v-bind="attrs" v-on="on">
                <v-icon color="white">  mdi-plus </v-icon>
            </v-btn> 
          </template>
          <create v-if="createDialog" v-bind:message="[company, statusss]" @closeCreateDialogQuotation="closeCreateDialogQuotation"/>
        </v-dialog>
        <!-- Editar venta -->
        <v-dialog v-model="editDialog" max-width="900px">
          <edit v-bind:quotation="sale" @closeDialogEditQuotation="closeDialogEditQuotation"/>
        </v-dialog>
        <!-- Enviar email -->
        <v-dialog v-model="emailDialog" max-width="700px">
          <email v-bind:quotation="sale" @closeDialogEmailQuotation="closeDialogEmailQuotation"/>
        </v-dialog>
        <!-- Enviar factura -->
        <v-dialog v-model="invoiceEmailDialog" max-width="700px">
            <v-card v-if="invoiceEmailDialog" class="py-5">
                <v-row class="ma-0">
                    <v-spacer/>
                        <v-card-title v-if="liga=='https://backendmf.unocrm.mx/'">Correo(s) a enviar factura B-{{invoice_to_send.folio_number}}</v-card-title>
                        <v-card-title v-else>Selecciona el correo al que enviaras la factura B-{{invoice_to_send.facturapi_invoices[0].folio_number}}</v-card-title>
                    <v-spacer/>
                </v-row>

                <v-row class="ma-0">
                    <v-spacer/>
                    <v-select small-chips v-if="liga=='https://backendmf.unocrm.mx/'" multiple label="emails" :items="mails" v-model="mails_to_send"></v-select>
                    <v-text-field v-else v-model="invoice_to_send.company.attributes.fiscal_email" label="Email"></v-text-field>
                    <v-spacer/>
                </v-row>

                <v-card-actions>
                    <v-row class="ma-0">
                        <v-spacer/>
                        <v-btn @click="sendInovice()" rounded color="primary" class="elevation-0">Enviar</v-btn>
                        <v-spacer/>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialogo confirmación de eliminación -->
        <div class="text-center">
            <v-bottom-sheet  v-model="sheet" inset>
                <v-sheet class="text-center" height="150px">
                    <div class="pt-6">
                    ¿Seguro que deseas borrar esta venta?
                    </div>
                    <v-btn class="mt-4" text color="error" @click="deleteSale()">
                    Eliminar
                    </v-btn>
                    <v-btn class="mt-4" text color="grey" @click="cancel('cancel')">
                    Cancelar
                    </v-btn>
                </v-sheet>
            </v-bottom-sheet>
        </div>
        <!-- Dialogo confirmación de cambio de estatus -->
        <div class="text-center">
            <v-bottom-sheet  v-model="sheet2" inset>
                <v-sheet class="text-center" height="150px">
                    <div class="pt-6">
                    ¿Seguro que deseas cambiar el estatus de esta cotización a "Cancelación"?
                    </div>
                    <v-btn class="mt-4" text color="primary" @click="confirmRejection()">
                    Si
                    </v-btn>
                    <v-btn class="mt-4" text color="grey" @click="cancel('cancel')">
                    No
                    </v-btn>
                </v-sheet>
            </v-bottom-sheet>
        </div>
        <!-- Motivo de Rechazo -->
        <v-dialog v-model="rejectionDialog" max-width="800px">
            <v-card class="px-12 pb-6 pt-8 elevtion-0" style="background-color:white;">
                Motivo de Rechazo:

                <v-autocomplete clearable v-model="editedItem.rejection_id" :items="rejectionsLists" label="Motivo de Cancelación" item-text="name" item-value="id">
                    <template slot="no-data" class="pa-2">No existen motivos relacionados.</template>                      
                </v-autocomplete>
                <v-textarea v-model="editedItem.rejection_comment" label="Descripcion"></v-textarea>

                <br>Inventario:<br>

                <v-list-item v-for="(item, i) in editedItem.items" :key="i" style="border-bottom:solid 1px grey;">
                    <v-list-item-content>
                        <span>{{item.quantity}} <span v-if="item.item.unit!=undefined">{{item.item.unit.name}}</span> | {{item.item.name}}</span>
                    </v-list-item-content>
                    <v-list-item-action style="width:200px!important">
                        <v-select :items="merma" v-model="item.rejection_status" label="Merma/Devolución" x-small rounded dense outlined></v-select>
                    </v-list-item-action>
                </v-list-item>
                <div v-if="permissions('creditNote') && editedItem.facturapi_invoices!=undefined && editedItem.facturapi_invoices.length>0">
                    <br>Nota de Crédito:<br>
                    

                    <v-radio-group v-model="generate_credit_note">
                        <v-radio label="Generar Nota de Crédito" :value="true"></v-radio>
                        <v-radio label="No Generar Nota de Crédito" :value="false"></v-radio>
                    </v-radio-group>
                </div>

                
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" class="mt-3" text @click="rejectionDialog=false">
                        Cancelar
                    </v-btn>
                    <v-btn color="blue darken-1" class="mt-3" text @click="saveRejection" :disabled="disbaledCancellation || process_cancelation" :loading="process_cancelation">
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- corte mostrador -->
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
        <!-- Editar detalle de venta -->
        <v-dialog v-model="editDialogDetail" max-width="650px">
          <EditDetailMF v-if="liga=='https://backendmf.unocrm.mx/'" v-bind:editedDetail="editedDetail" @closeDialogEditDetail="closeDialogEditDetail"/>
          <edit-detail v-else v-bind:editedDetail="editedDetail" @closeDialogEditDetail="closeDialogEditDetail"/>
        </v-dialog>
        <!-- Agregar detalle de venta -->
        <v-dialog v-model="addDialogDetail" :max-width="liga=='https://backendmf.unocrm.mx/'?'800px':'650px'">
            <AddDetailMF v-if="liga=='https://backendmf.unocrm.mx/'" v-bind:addDetail="addDetail" @closeDialogAddDetail="closeDialogAddDetail" :price_list="price_list"/>
            <add-detail v-else v-bind:addDetail="addDetail" @closeDialogAddDetail="closeDialogAddDetail"/>
        </v-dialog>

        <!-- Crear cobranza -->
        <v-dialog v-model="collectionDialog" max-width="1000px">
            <collection-create
                v-if="collectionDialog"
                :key="collectionDialogKey"
                :prefill="collectionPrefill"
                @closeCreateDialogCollection="closeCollectionDialog"
            />
        </v-dialog>

        <v-dialog v-model="filterMobile" fullscreen hide-overlay transition="dialog-bottom-transition">
            <filterSales style="background:white;" v-bind:company="company" @filtersSale="filtersSale"/>
        </v-dialog>

        <!-- Dialogo ticket POS -->
        <v-dialog v-model="dialogTicket" max-width="350px">
            <bdbTicket v-if="liga == 'https://backendbdb.unocrm.mx/'" @cerrar="cerrarTicket" v-bind:ticket="ticket"/>
            <ticket v-else @cerrar="cerrarTicket" v-bind:ticket="ticket"></ticket>
        </v-dialog> 

        <!-- Dialogo Factura -->
        <v-dialog v-model="invoice_dialog" max-width="800px">
            <invoice @cerrarInvocie="cerrarInvocie" v-bind:invoice="invoice"></invoice>
        </v-dialog> 

        <!-- nota de credito -->
        <v-dialog v-model="credit_note_dialog" max-width="900px">
            <creditNote v-if="editedItem.facturapi_invoices!=undefined" :invoice_to_note="editedItem.facturapi_invoices[0]"/>
        </v-dialog> 

        <DuplicateSale v-if="duplicate.open" v-model="duplicate.open" :sale-id="duplicate.id" @duplicated="getDataFromApi"/>

    </v-container>
</template>

<script>
import Invoice from "../sales/invoice"
import Totals from "../sales/totals"
import moment from 'moment';
import axios from "axios";
import XLSX from 'xlsx';
import Filter from "../sales/filter"
import Create from "../quotations/create"
import Edit from "../quotations/edit"
import Email from "../quotations/sendQuotation"
import EditDetail from "../sales/detail/edit"
import AddDetail  from "../sales/detail/create"
import EditDetailMF from "../sales/detail/editMF"
import AddDetailMF  from "../sales/detail/createMF"
import CollectionCreate from "../collections/create"
import Ticket from "../pos/Ticket"
import BdbTicket from "../pos/BdbTicket"
import DuplicateSale from '../quotations/duplicate.vue'
export default {
    props:{
        company:String
    },
    components: {
        'filterSales':Filter,
        'create':Create,
        'edit':Edit,
        'email':Email,
        'totals':Totals,
        'edit-detail':EditDetail,
        'add-detail':AddDetail,
        'ticket':Ticket,
        'bdbTicket':BdbTicket,
        'invoice':Invoice,
        'EditDetailMF':EditDetailMF,
        'AddDetailMF':AddDetailMF,
        'collection-create':CollectionCreate,
        DuplicateSale
    }, 
    data: () => ({
        exporting:false,
        mails:[],
        mails_to_send:[],
        price_list:undefined,
        generate_credit_note:false,
        credit_note_dialog:false,
        invoiceEmailDialog:false,
        invoice_to_send:{},
        invoice:{},
        invoice_dialog:false,
        dialogTicket:false,
        ticket:{},
        salesLength:0,
        filterMobile:false,
        editDialogDetail:false,
        addDialogDetail:false,
        collectionDialog:false,
        collectionPrefill:null,
        collectionDialogKey:0,
        editedDetail:'',
        addDetail:'',
        merma:['Merma', 'Devolución'],
        editedItem:{
            id:'',
            status:'',
            rejection_comment:'',
            rejection_id:'',
            items: [],
            last_updated_by_user_id:''
        },
        totals:'',
        process_cancelation:false,
        editedBarSales:'',
        searchInput:'',
        tableGraph:true,
        showTable:true,
        totalSales: 0,
        sales: [],
        loading: true,
        options: {
            page: 1,
            itemsPerPage: 15,
            sortBy: [],
            sortDesc: [],
        },
        snackbar: {
            show: false,
            message: null,
            color: null
        },
        gris:false,
        statusss:'vendido',
        sale:'',
        invoiceDialog: false,
        sheet2: false,
        sheet: false,
        filters: false,
        emailDialog: false,
        editDialog: false,
        createDialog: false,
        detailDialog:false,
        rejectionDialog:false,
        deleteId:'',
        rejectionData:'',
        rejectionId:'',
        filterStorageLength:0,
        headersBar:[
            { text: 'Folio', value: 'id' },
            { text: 'Empresa', value: 'company' },
            { text: 'Total', value: 'total' },
            { text: 'Serie', value: 'type' },
            { text: 'Factura/Remisión', value: 'invoice' },
            { text: 'Fecha F/R', value: 'invoice_date' },
            { text: 'Vendedor', value: 'salesman' },
        ],
        duplicate:{ open:false, id:null }
    }),
    watch: {
        options: {
            handler () {
                this.getDataFromApi()
            },
            deep: true,
        },
        routeSaleId(){
            this.options.page = 1
            this.getDataFromApi()
        },
    },
    mounted(){
        Echo.channel('sales').listen('OrderInProduction', (e) => {
            var updatedSale = this.sales.filter(sale=>sale.id == e[0])[0]
            if(updatedSale!=undefined){
                this.sales.filter(sale=>sale.id == e)[0].is_in_production = true
            }
        })
        Echo.channel('sales_dispatched').listen('OrderDispatched', (e) => {
            var updatedSale = this.sales.filter(sale=>sale.id == e[0])[0]
            if(updatedSale!=undefined){
                this.sales.filter(sale=>sale.id == e)[0].production_dispatched = true
            }
        })
    },
    computed: {
        liga(){
            return process.env.VUE_APP_BACKEND_ROUTE
        },
        // Folio que llega por link (/sales/:sale_id): se muestra solo, sin mezclarlo con los filtros guardados.
        routeSaleId(){
            return this.$route.params.sale_id
        },
        canCreateSales(){
            if(this.liga !== 'https://backend.ferreteriaenlinea.com/'){
                return true
            }
            return this.permissions('createSales')
        },
        showCompany(){
            if(this.company == null){
                if(this.liga == 'https://backendbdb.unocrm.mx/'){
                    return { text: 'Cliente', value: 'company_id',}
                }else{
                    return { text: 'Empresa', value: 'company_id',}
                }
            }else{
                return false
            }
        },
        utilityAndCost(){
            var headers = []
            if(this.permissions('utilities')){
                headers.concat([
                { text: 'Utilidad Unitaria', value: 'utility_per_item',},
                { text: 'Utilidad Total', value: 'utility',}])
            }
            if(this.permissions('view_costs')){
                headers.concat([
                { text: 'Costo Unitario', value: 'cost',},
                { text: 'Costo Total', value: 'total_cost',}])
            }
            
            return headers
        },
        headers2(){
            var headers = [
                //{ text: 'Codigo Macro', value: 'macro',},
                { text: 'Producto | Servicio', value: 'item',},
                { text: 'Código 1', value: 'code_one',},
                { text: 'Cantidad', value: 'totalWeight',},
                { text: 'Precio Unitario sin IVA', value: 'price',},
                { text: 'Descuento', value: 'discount'}
            ]

            if(this.liga!='https://backendmf.unocrm.mx/'){
                /*headers = headers.concat([{ text: 'Descuento', value: 'discount'}])
            }else{*/
                headers = headers.concat([{ text: 'Precio Unitario con IVA', value: 'price_iva'}])
            }

            return headers.concat(this.viewCosts).concat(this.utilityPermission).concat([{ value: 'actions', sortable: false, align: 'end', }])
        },
        disbaledCancellation(){
            for(var i=0; i<this.editedItem.items.length; i++){
                if(this.editedItem.items[i].rejection_status==null){
                    return true
                }
            }
            return false
        },
        utilityPermission(){
            if(this.permissions('utility')){
                return {text: 'Utilidad', value:'utility'}
            }else{
                return false
            }
        },
        viewCosts(){
            if(this.permissions('view_costs')){
                return [{ text: 'Costo Unitario', value: 'cost' }, { text: 'Costo Total', value: 'total_cost',}]
            }
            return []
        },
        currentUser:{
            get(){
                return this.$store.state.currentUser.user;
            }
        },
        headers(){ 
            return [
            { text: '', value: 'data-table-expand' },
            { value: 'actions', sortable: false, align: 'end', },
            { text: 'Folio', value: 'id' },
            { text: 'Factura', value: 'invoice', sortable: false },

            this.liga!='https://backend.ferreteriaenlinea.com/'?{ text: 'Remisión', value: 'remission', sortable: false }:'',

            { text: 'Fecha Venta', value: 'date' },
            this.showCompany,
            this.liga!='https://backend.ferreteriaenlinea.com/'?{ text: this.liga=='https://backendmf.unocrm.mx/'?'Comedor':'Sucursal', value: 'company_branch' }:'',
            { text: 'Vendedor', value: 'user_id' },
            this.liga!='https://backendmf.unocrm.mx/'?{ text: 'Subtotal', value: 'subtotal' }:'',
            this.liga!='https://backendmf.unocrm.mx/'?{ text: 'IVA', value: 'iva' }:'',
            { text: 'Total', value: this.liga!='https://backendmf.unocrm.mx/'?'total':'subtotal' },
            { text: 'Pagos', value: 'payments', sortable: false },
            { text: 'Cobranza(s)', value: 'collections', sortable: false },
            { text: 'Fecha(s) de Pago(s)', value: 'collections_date', sortable: false },
            { text: 'Adeudo', value: 'due_balance', sortable: false },
            { text: 'Saldo Vencido', value: 'past_due_balance', sortable: false },
            { text: 'Lista de Precios', value: 'price_list' },
            { text: 'Estatus de Pago', value: 'payment_status', sortable: false },
            this.utilityPermission,
            { text: 'Fecha Factura', value: 'invoice_date' },
            { text: 'Fecha de Vencimiento', value: 'balance_due_date', sortable: false },
            { text: 'Mostrador', value: 'bar' },

            this.liga!='https://backend.ferreteriaenlinea.com/'?{ text: 'Peso', value: 'sale_total_weight' }:'',

            //{ text: 'Fecha de Entrega', value: 'shipping_date', sortable: false },
            { text: 'Serie', value: 'type' },
            
            //{ text: 'Impresa', value: 'printed' },
            { text: 'Días Factura', value: 'days_after_invoice_date', sortable: false },
            { text: 'Días Vencido', value: 'balance_due_days', sortable: false },
            //{ text: 'Surtido', value: 'production_dispatched'},

            /*{ text: 'Autorizado por', value: 'authorized_by'},
            { text: 'Motivo de Autorización', value: 'authorization_reason'},*/

            { text: 'Creación', value: 'created_at' },
            { text: 'Usuario Creador', value: 'created_by_user_id' },
            { text: 'Edición', value: 'updated_at' },
            { text: 'Usuario Editor', value: 'last_updated_by_user_id' },
            
        ]},
        rejectionsLists(){
            return this.$store.state.rejection.rejections;
        },
    },
    methods: { 
        openDuplicate(id){
            if(!this.canCreateSales){
                return
            }
            this.duplicate = { open:true, id }
        },
        sendInovice(){
            if(this.liga=='https://backendmf.unocrm.mx/'){
                axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/custom-invoice",{
                    "invoice_id": this.invoice_to_send.facturapi_invoices[0].facturapi_id,
                    "emails": this.mails_to_send
                }).then(response=>{
                    this.snackbar = {
                        message: 'Factura enviada con éxito',
                        color: 'success',
                        show: true
                    }
                    this.invoiceEmailDialog = false
                    this.invoice_to_send = {}
                }).catch(error=>{
                    this.snackbar = {
                        message: error.response.data.message,
                        color: 'red',
                        show: true
                    }
                })
            }else{
                let config = {
                    headers: {
                        'Authorization': "Bearer " + process.env.VUE_APP_FACTURAPI_TOKEN
                    }
                }
                axios.post('https://www.facturapi.io/v2/invoices/' + this.invoice_to_send.facturapi_invoices[0].facturapi_id + '/email', {email: this.invoice_to_send.company.attributes.fiscal_email},config).then((resp) => {
                    this.snackbar = {
                        message: 'Factura enviada con éxito',
                        color: 'success',
                        show: true
                    }
                    this.invoiceEmailDialog = false
                    this.invoice_to_send = {}
                }).catch(error=>{
                    this.snackbar = {
                        message: error.response.data.message,
                        color: 'red',
                        show: true
                    }
                })
            }
        },
        downloadInvoice(invoices){
            if(this.liga == 'https://backendmf.unocrm.mx/' || this.liga == 'http://127.0.0.1:8000/'){
                let config = {
                    responseType: 'arraybuffer',
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("xn8(*&^%$#47b*g3f76gw3*&^fn734gf8q*&^&^&mwmeg934g8whmre7ngN&G#*!NG@*&#GF(!*#gm1n428fm1g3n84gmf*^$&(%$)e3298negmg"),
                        'Content-Type': 'application/json',
                        'Accept': 'application/pdf'
                    }
                }
                axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/custom-invoice/", { "invoice_id":invoices[0].facturapi_id}, config).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', invoices[0].uuid+ '.pdf'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            }else{
                let config = {
                    responseType: 'arraybuffer',
                    headers: {
                        'Authorization': "Bearer " + process.env.VUE_APP_FACTURAPI_TOKEN,
                        'Content-Type': 'application/json',
                        'Accept': 'application/pdf'
                    }
                }
                axios.get('https://www.facturapi.io/v2/invoices/' + invoices[0].facturapi_id + '/pdf', config).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', invoices[0].uuid+ '.pdf'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            }
        },
        downloadXml(invoices){
            let config = {
                responseType: 'arraybuffer',
                headers: {
                    'Authorization': "Bearer " + process.env.VUE_APP_FACTURAPI_TOKEN,
                    'Content-Type': 'application/json',
                    'Accept': 'application/xml'
                }
            }
            axios.get('https://www.facturapi.io/v2/invoices/' + invoices[0].facturapi_id + '/xml', config).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', invoices[0].uuid+ '.xml'); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
        },
        addProduct(quotation){
            if(!this.canCreateSales){
                return
            }
            console.log('-----quotation')
            console.log(quotation)
            console.log('-----quotation')
            this.addDialogDetail = true
            this.addDetail = quotation.id*1,
            this.price_list = quotation.price_list?.replace(/%/g, '') * 1
        },
        rejectionSwitchLabel(value){
            if(value == null || value){
                return 'Devolución'
            }else{
                return 'Merma'
            }
        },
        rejection(item){
            this.editedItem.id = item.id
            this.editedItem.status = 'cancelled'
            this.editedItem.items = item.items
            this.rejectionDialog = true
            this.editedItem.self_invoice_url = item.self_invoice_url
            this.editedItem.facturapi_receipt_id = item.facturapi_receipt_id
        },
        saveRejection(){
            this.sheet2 = true
        },
        confirmRejection(){
            this.process_cancelation = true
            this.editedItem.last_updated_by_user_id = this.currentUser.id
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sale/cancel",Object.assign(this.editedItem)).then(response=>{
                let config = {
                    headers: {
                        'Authorization': "Bearer " + process.env.VUE_APP_FACTURAPI_TOKEN
                    }
                }
                if(this.editedItem.facturapi_invoices!=undefined && this.editedItem.facturapi_invoices.length>0){
                    const chunks = this.editedItem.facturapi_invoices.filter(invoice=>invoice.status != "canceled")
                    let index = 0;
                    const sendRequests = () => {
                        if (index >= chunks.length) {
                            this.snackbar = {
                                message: 'Factura(s) cancelada(s) con éxito',
                                color: 'success',
                                show: true
                            }
                            this.getDataFromApi()
                            this.cancel('save')
                            return;
                        }
                        // Se crea un array con las solicitudes que se enviarán en esta iteración
                        const requests = chunks[index].map(invoice => axios.delete(`${process.env.VUE_APP_BACKEND_ROUTE}api/v2/facturapi/invoices/${invoice.facturapi_id}`, config).then(response=>{
                        //const requests = chunks[index].map(invoice => axios.delete(`https://www.facturapi.io/v2/invoices/${invoice.facturapi_id}`, config).then(response=>{
                            this.index = this.index + 1
                        }));
                        // Se envían las solicitudes usando Promise.all()
                        Promise.all(requests).then(() => {
                            index++;
                            // Se espera un momento antes de enviar la siguiente tanda de solicitudes
                            setTimeout(sendRequests, 1000);
                        }).catch(error => {
                            this.snackbar = {
                                message: error.response.data.message,
                                color: 'red',
                                show: true
                            }
                            // Si hay un error, se detiene el proceso
                        });
                    };
                    sendRequests();
                }else if(this.editedItem.facturapi_receipt_id!=undefined){
                    axios.delete('https://www.facturapi.io/v2/receipts/' + this.editedItem.facturapi_receipt_id, config).then(resp => {
                        this.snackbar = {
                            message: 'Recibo cancelado con éxito',
                            color: 'success',
                            show: true
                        }
                        this.getDataFromApi()
                        this.cancel('save')
                    }).catch(error=>{
                        this.snackbar = {
                            message: error.response.data.message,
                            color: 'red',
                            show: true
                        }
                    })
                }else{
                    this.getDataFromApi()
                    this.cancel('save')
                }
            }).catch(error => {
                this.snackbar = {
                    message: "Error al cancelar la venta",
                    color: 'error',
                    show: true
                }
            })
        },
        barSales(){
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/bar_sales_list").then(response => {
                this.editedBarSales = response.data.data.map(id=>{
                    return{
                        id:id.id,
                        company:id.company.attributes.name,
                        total:id.total,
                        type:id.type,
                        invoice:id.invoice,
                        invoice_date:id.invoice_date,
                        salesman:id.salesman,
                    }
                })
                this.invoiceDialog = true
            })
        },
        getDataFromApi () {
            this.loading = true
            this.apiCall().then(data => {
                this.editedBarSales
                this.sales = data.items
                this.totalSales = data.total
                this.loading = false
            })
        },
        filterStorage(){
            if(localStorage.getItem('filtersSales')!=null){
                false
            }else{
                return true
            }
        },
        apiCall () {
            return new Promise((resolve, reject) => {
                let items = []
                let total = 0
                const query = this.buildSalesQuery(false, false)
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sales?" + query).then(response => {
                    this.salesLength = response.data.meta.total
                    items = this.mapSales(response.data.data)
                    total = response.data.meta.total
                    resolve({
                        items,
                        total,
                    })
                })
            })
        },
        salesman(user){
            if(user!=undefined){
                if(user.last!=null){
                    return user.name + ' ' + user.last
                }else{
                    return user.name
                }
            }
        },
        priceList(id){
            if(id!=undefined){
                return id.name
            }
        },
        macro(macro){
            if(macro!=null){
                return macro + ' | '
            }else{
                return ''
            }
        },
        mapSales(sales){
            sales = sales.map(id=>{
                return{
                    company:id.company,
                    production:id.production,
                    datePicker: false,
                    id:id.id,
                    company_branch:id.company_branch,
                    company_id: this.macro(id.company.attributes.macro) + this.nombre(id.company.attributes),
                    companyID: id.company.id,
                    delivery_address:id.company.attributes.delivery_address,
                    razon_social: id.company.attributes.razon_social,
                    direccion: id.company.attributes.address,
                    delivery_time: id.company.attributes.delivery_time,
                    macro:id.company.attributes.macro,

                    collections_date:id.collections_date,

                    //contact:this.contact(id.contact),
                    user_id:this.salesman(id.company.attributes.user),
                    created_by_user_id:this.salesman(id.created_by_user_id),
                    last_updated_by_user_id:this.salesman(id.last_updated_by_user_id),
                    price_list:this.priceList(id.price_list), 
                    utility:(id.utility.toFixed(2)*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),

                    total:(id.total*1),
                    pdf:id.pdf,
                    pdf2:id.pdf2,
                    note:id.note,
                    internal_note:id.internal_note,
                    bar:id.bar,
                    date:id.date,
                    type:id.type,
                    shipping:id.shipping,
                    items:id.items.map(item=>{
                        return{
                            cost: item.cost,
                            id: item.id,
                            item: item.item,
                            price: item.price,
                            quantity: item.quantity,
                            quotation: item.quotation,
                            rejection_status: item.rejection_status,
                            value: item.value,
                            is_in_production:id.is_in_production,
                            production_dispatched:id.production_dispatched,
                            discount:item.discount
                        }
                    }),
                    created_at:id.created_at.slice(0, 18),
                    updated_at:id.updated_at.slice(0, 18),
                    subtotal:(id.subtotal*1),
                    iva:(id.iva*1),                 
                    printed:id.printed,
                    invoice_date:this.invoiceData(id.facturapi_invoices, 'date'),                    
                    payments:(id.payments*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                    collections:id.collections.map(id=>id.id),
                    due_balance:(id.due_balance*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                    due_balance_raw:(id.due_balance*1),
                    past_due_balance:(id.past_due_balance*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                    balance_due_date:id.balance_due_date.slice(0, 10),//falta filtro
                    balance_due_days:id.payment_status=='Vencida'?id.balance_due_days:'',
                    days_after_invoice_date:id.days_after_invoice_date,
                    status:id.status,

                    invoice:this.invoiceData(id.facturapi_invoices, 'invoice'),
                    remission:id.remission,

                    payment_status:id.payment_status,//falta filtro
                    payment_method_raw:id.payment_method,
                    company_raw:id.company,
                    sale_total_weight: id.sale_total_weight,
                    shipping_date:id.shipping_date,//falta filtro
                    is_in_production:id.is_in_production,
                    production_dispatched:id.production_dispatched,
                    facturapi_invoices:id.facturapi_invoices,
                    self_invoice_url:id.self_invoice_url,
                    facturapi_receipt_id:id.facturapi_receipt_id,
                    authorized_by:this.nombre(id.authorized_by),
                    authorization_reason:id.authorization_reason,
                    payment_form:id.payment_form
                }
            });
            return sales
        },
        invoiceData(invoice, data){
            const last_invoice = invoice.filter(i=>i.type == "I")[0]
            if(last_invoice!=undefined){
                switch(data){
                    case 'invoice': return 'B-'+last_invoice.folio_number
                    case 'date': return last_invoice.date
                }
            }
        },
        nombre(empresa){
            if(empresa!=undefined){
                if(empresa.name == undefined || empresa.name == '' || empresa.name == null){
                    return empresa.razon_social
                }else{
                    return empresa.name
                }
            }
        },
        printTicket(item){
            if(process.env.VUE_APP_BACKEND_ROUTE == "https://suministros.uno/"){
                axios.put(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/quotation/print-sale",Object.assign(item)).then(response=>{
                    localStorage.setItem('printTicket', item.id);
                    window.open("/");
                    this.$nextTick(() => {
                        if (this.options.sortBy.length === 1 && this.options.sortDesc.length === 1) {
                            if(this.options.sortDesc){
                                var sort = '-' + this.options.sortBy[0]
                                this.$store.dispatch('quotation/getSales', {'pageNumber':this.options.page, 'sort':sort})
                            }else{
                                var sort = this.options.sortBy[0]
                                this.$store.dispatch('quotation/getSales', {'pageNumber':this.options.page, 'sort':sort})
                            }
                            
                        }else{
                            this.$store.dispatch('quotation/getSales', {'pageNumber':this.options.page, 'sort':'id'})
                        }
                    })
                })
            }else if(this.liga=='https://backendmf.unocrm.mx/'){
                    localStorage.setItem('printTicketMF', item.id);
                    window.open("/", "_blank");
                    this.$nextTick(() => {
                        if (this.options.sortBy.length === 1 && this.options.sortDesc.length === 1) {
                            if(this.options.sortDesc){
                                var sort = '-' + this.options.sortBy[0]
                                this.$store.dispatch('quotation/getOrders', {'pageNumber':this.options.page, 'sort':sort})
                            }else{
                                var sort = this.options.sortBy[0]
                                this.$store.dispatch('quotation/getOrders', {'pageNumber':this.options.page, 'sort':sort})
                            }
                            
                        }else{
                            this.$store.dispatch('quotation/getOrders', {'pageNumber':this.options.page, 'sort':'id'})
                        }
                    })
                }else {
                console.log(item)
                this.ticket = [item].map(id=>{return{
                    id:id.id,
                    company_id:id.companyID,
                    company:id.company,
                    note:id.note,
                    bar:id.bar,
                    subtotal:id.subtotal,
                    iva:id.iva,
                    total:id.total,
                    date:id.date,
                    status:id.status,

                    created_at:id.created_at,

                    user_id:this.currentUser.id,
                    payment_form:id.payment_form,
                    payment_method:id.payment_method_raw,
                    
                    items:id.items.map(i=>{return{
                        quantity:i.quantity,
                        product:i.item,
                        price:i.price,
                    }}),

                    self_invoice_url:id.self_invoice_url,
                    
                }})[0]
                this.dialogTicket=true;
            }
        },
        itemRowBackground: function (item) {
            return item.status == 'cancelled' ? 'cancelled' : 'normal'
        },
        openFilter(){
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.filterMobile = true
            }else{
                if(this.filters == false){
                    this.$emit("closeDrawer", false);
                    this.filters = true
                }else{
                    this.$emit("closeDrawer", true);
                    this.filters = false
                }
            }
        },
        permissions(permission){
            if(this.currentUser.id==1){
                return true
            }else if(this.currentUser.permissions!=undefined){
                if(this.currentUser.permissions.includes(permission)){
                    return true
                }else{
                    return false
                }
            }else{
                return false
            }
        },
        clearRouteSale(){
            this.$router.push('/new-sales')
        },
        filtersSale: function(params) {
            if(this.routeSaleId && localStorage.getItem('filtersSales') !== this.routeSaleFiltersSnapshot){
                // Al aplicar o limpiar filtros se quita el folio del link; el watch de la ruta recarga.
                this.filterMobile = false
                this.$router.replace('/new-sales')
                return
            }
            this.options.page = 1
            this.showTable = false
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.filterMobile = false
            }
            this.$nextTick(() => {
                this.showTable = true
                this.getDataFromApi()
            })
        },
        closeDialogEditQuotation: function(params) {
            this.editDialog = false;
            //this.$store.dispatch('quotation/getQuotations')
            this.getDataFromApi()
        },
        cerrarInvocie: function(params) {
            this.invoice_dialog = false;
            this.snackbar = {
                message: 'Factura generada con éxito',
                color: 'success',
                show: true
            }
            this.getDataFromApi()
        },
        closeCreateDialogQuotation: function(params) {
            this.createDialog = false;
            //this.$store.dispatch('quotation/getQuotations')
            this.getDataFromApi()
        },
        closeDialogEmailQuotation: function(params) {
            this.emailDialog = false;
        },
        closeDialogEditDetail: function(params) {
            this.editDialogDetail = false
            this.getDataFromApi()
        },
        closeDialogAddDetail: function(params) {
            this.addDialogDetail = false
            this.getDataFromApi()
        },
        openCollection(item){
            const companyId = item.companyID || item.company_raw?.id || item.company?.id
            const amount = item.due_balance_raw !== undefined && item.due_balance_raw !== null
              ? Number(item.due_balance_raw || 0)
              : Number(item.total || 0)
            this.collectionPrefill = {
                company_id: companyId,
                sale_id: item.id,
                amount,
                payment_method_id: item.payment_method_raw?.id || item.payment_method_raw || null,
                company: item.company_raw || item.company || null
            }
            this.collectionDialogKey = Date.now()
            this.collectionDialog = true
        },
        closeCollectionDialog(){
            this.collectionDialog = false
            this.collectionPrefill = null
        },
        exportExcel: async function (all = false) {
            this.exporting = true
            try {
                const response = await axios.get(
                    process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sales?" + this.buildSalesQuery(all, true),
                    {
                        responseType: 'blob',
                        headers: {
                            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        }
                    }
                )
                this.downloadFile(response.data, this.getExportFilename(response))
            } finally {
                this.exporting = false
            }
        },
        defaultDateBetween(){
            var date = new Date()
            const start = new Date(date.getFullYear(), date.getMonth(), 1).toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 10)
            const end = new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 10)
            return `${start},${end}`
        },
        buildSalesQuery(all = false, exportFile = false){
            const { sortBy = [], sortDesc = [], page, itemsPerPage } = this.options
            const params = new URLSearchParams()

            this.filterStorageLength = localStorage.getItem('filtersSalesLength')

            if(this.company!=undefined){
                params.set('filter[company_id]', this.company)
            }
            if(this.routeSaleId!=undefined){
                params.set('filter[id]', this.routeSaleId)
                this.routeSaleFiltersSnapshot = localStorage.getItem('filtersSales')
            } else if(localStorage.getItem('filtersSales')!=null){
                const storedParams = new URLSearchParams(JSON.parse(localStorage.getItem('filtersSales')))
                storedParams.forEach((value, key) => {
                    if (key !== 'filter[company_id]' || this.company == undefined) {
                        params.set(key, value)
                    }
                })
            } else if (this.company==undefined) {
                params.set('filter[date_between]', this.defaultDateBetween())
            }
            if (sortBy.length === 1 && sortDesc.length === 1) {
                params.set('sort', (sortDesc[0] ? '-' : '') + sortBy[0])
            }

            const queryPage = all ? 1 : page
            const queryItemsPerPage = all ? (this.totalSales || this.options.itemsPerPage) : itemsPerPage
            params.set('page', queryPage)
            params.set('itemsPerPage', queryItemsPerPage)

            if(exportFile){
                params.set('export', 1)
            }

            return params.toString()
        },
        getExportFilename(response) {
            const disposition = response.headers?.["content-disposition"] || "";
            const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
            if (match && match[1]) {
                return match[1].replace(/['"]/g, "");
            }
            return `sales_${new Date().toISOString().slice(0, 10)}.xlsx`;
        },
        downloadFile(blobData, filename) {
            const url = window.URL.createObjectURL(new Blob([blobData]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        },
        deleteSale(){
            axios.delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/quotation/delete/"+this.deleteId).then(response => {
                this.deleteId = ''
                this.sheet = false
                this.getDataFromApi()
            }).catch(error => {
                this.snackbar = {
                    message: error.response.data.message,
                    color: 'error',
                    show: true
                }
            });
        },
        sendEmail (id) {
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/sale_items/' + id).then(response => {
                this.editedDetail = response.data
                this.emailDialog = true
            })
        },
        sendInvoiceEmail(item){
            this.mails = [item.company.attributes.fiscal_email, item.company.attributes.email].concat(this.$store.state.contact.contacts.filter(contact=>contact.company_id == item.company.attributes.company_id).map(c=>c.email))
            this.invoiceEmailDialog = true
            this.invoice_to_send = item
        },
        cancel(type){
            this.editedItem={
                id:'',
                status:'',
                rejection_comment:'',
                rejection_id:'',
                items: [],
                last_updated_by_user_id:''
            }
            this.rejectionDialog = false
            this.sheet = false
            this.sheet2 = false
            this.process_cancelation = false
            if(this.facturapi_invoices && type=='save'){
                this.credit_note_dialog = true
            }
        },
        closeCreditNoteDialog: function(params){
            this.credit_note_dialog = false
            this.cancel('cancel')
        },
        deleteItem (item) {
            this.deleteId = item.id
            this.sheet = true
        },
        editItem(id){
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sales?filter[id]=" + id).then(response => {
                this.sale = response.data.data.map(id=>{
                    return{
                        id:id.id,
                        company_id:this.existe(id.company).toString(),
                        company_branch_id:this.existe(id.company_branch),
                        contact_id:this.existe(id.contact),
                        user_id:this.existe(id.user),
                        pdf:id.pdf2,
                        note:id.note,
                        internal_note:id.internal_note,
                        bar:id.bar,
                        date:id.date,
                        type:id.type,
                        invoice:id.invoice,
                        last_updated_by_user_id:this.existe(id.last_updated_by_user_id),
                        invoice_date:id.invoice_date,
                        status:id.status,
                        self_invoice_url:id.self_invoice_url,
                        facturapi_receipt_id:id.facturapi_receipt_id,
                        payment_method:id.payment_method,
                        companies:[id.company],
                        company_branches:[id.company_branch],
                        has_invoices:id.facturapi_invoices.length>0
                    }
                })[0]
                this.editDialog = true
            })
        },
        cerrarTicket: function(params) {
            this.dialogTicket=false;
        },
        existe(item){
            if(item!=null){
                return item.id*1
            }else{
                return ''
            }
        },
        generateInvoice(item){
            console.log('--')
            console.log(item)
            this.invoice = [item].map(id=>{return{
                related_documents: (item.facturapi_invoices!=undefined && item.facturapi_invoices.length>1 && item.facturapi_invoices[0]!=undefined) ? item.facturapi_invoices.map(fac=>fac.uuid) : undefined,
                items:id.items.map(i=>{return {
                    quantity: i.quantity,
                    product_id: i.item.facturapi_id,
                    product: i.item,
                    price: i.price,
                    value: i.value,
                    discount: i.discount != null ? i.discount : 0,
                }}),
                products: id.items,
                payment_form: "",
                payment_method: "",
                use: "",
                conditions: "",
                customer: id.company.attributes.facturapi_id,
                email: id.company.attributes.fiscal_email,
                company: id.company.attributes,
                date: new Date().toLocaleString('sv-SE', { timeZone: 'America/Monterrey' }).slice(0, 10),
                external_id: id.id,
                series: this.liga=='https://backendmf.unocrm.mx/' ? 'CEDIS' : id.type,
                note:id.note,
                internal_note:id.internal_note,
                balance_due_date:id.balance_due_date,
                company_branch:id.company_branch
            }})[0]
            console.log('-')
            console.log(this.invoice)
            this.invoice_dialog = true
            console.log('--')
        },
        saveInvoice(){
            this.gris = true
            var edited = []
            for(var i=0; i<this.editedBarSales.length; i++){
                if(this.editedBarSales[i].invoice!=''&&this.editedBarSales[i].invoice_date!=null){
                    edited=edited.concat(this.editedBarSales[i])
                }
            }
            this.$nextTick(() => {
                axios.put(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/quotation/bar-bulk-update", edited.map(id=>{
                    return{
                        id:id.id,
                        invoice:id.invoice,
                        invoice_date:id.invoice_date,
                    }
                })).then(response=>{
                    this.getDataFromApi()
                    this.gris = false
                    this.searchInput = ''
                    this.invoiceDialog = false
                }).catch(error => {
                    this.snackbar = {
                        message: error.response.data.message,
                        color: 'error',
                        show: true
                    }
                })
                
            })
        },
        editDetail(id){
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/sale_items/' + id).then(response => {
                this.editedDetail = [response.data].map(id=>{return{
                    ...id,
                    price:id.price / (1 - (id.discount / 100)),
                    price_list:this.sales.filter(s=>s.id==id.quotation_id).map(id=>id.price_list)[0]?.replace(/%/g, '') * 1
                }})[0]
                this.editDialogDetail = true
            })
        },
        deleteDetail(id){
            axios.delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sale_items/" + id).then(response => {
                this.getDataFromApi()
            }).catch(error => {
                this.snackbar = {
                    message: error.response.data.message,
                    color: 'error',
                    show: true
                }
            });
        },
    }
}
</script>
<style>
    .cancelled {
        background-color: #fff5d7
    }
    .normal {
        background-color: white
    }
    .v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
        box-shadow: none!important;
        background: #f7f7f7;
    }
    .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 0%), 0px 2px 2px 0px rgb(0 0 0 / 0%), 0px 1px 5px 0px rgb(0 0 0 / 0%)!important;
    }
</style>
